import ApiService from '@/services/core/api.service'

const CropVarietyService = {
  async get (query) {
    return ApiService.get(`admin/crop-varieties?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/crop-varieties', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/crop-varieties/${payload.id}`, payload)
  }
}

export default CropVarietyService
